import React, { useMemo } from "react";
import { useLandingLang } from "../../i18n/LandingLangContext";

// ... (MANTENER TODOS LOS ICONOS SVG IGUAL QUE ANTES) ...
// (Por brevedad no repito los iconos BrainIcon, HistoryIcon, etc.
//  Asegúrate de dejarlos tal cual estaban en tu archivo anterior)

// --- MISMOS ICONOS DE ANTES ---
function BrainIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z" />
      <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z" />
      <path d="M12 5v13" />
      <path d="M5.5 16.5e-7q2 0 2.5 2.5" />
    </svg>
  );
}
function HistoryIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
      <path d="M3 3v5h5" />
      <path d="M12 7v5l3 3" />
    </svg>
  );
}
function DumbbellIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="m6.5 6.5 11 11" />
      <path d="m21 21-1-1" />
      <path d="m3 3 1 1" />
      <path d="m18 22 4-4" />
      <path d="m2 6 4-4" />
      <path d="m3 10 7-7" />
      <path d="m14 21 7-7" />
    </svg>
  );
}
function HeartHandshakeIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
      <path d="M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08v0c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.92 0l2.96 2.97" />
    </svg>
  );
}
function PaletteIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <circle cx="13.5" cy="6.5" r=".5" fill="currentColor" />
      <circle cx="17.5" cy="10.5" r=".5" fill="currentColor" />
      <circle cx="8.5" cy="7.5" r=".5" fill="currentColor" />
      <circle cx="6.5" cy="12.5" r=".5" fill="currentColor" />
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
    </svg>
  );
}
function WindIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2" />
      <path d="M9.6 4.6A2 2 0 1 1 11 8H2" />
      <path d="M12.6 19.4A2 2 0 1 0 14 16H2" />
    </svg>
  );
}
function ImageIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
      <circle cx="9" cy="9" r="2" />
      <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
    </svg>
  );
}

// El icono se elige por imageKey (estable en los 3 idiomas), no por el titulo traducido.
function pickIcon(imageKey = "") {
  const map = {
    therapy_cognitive: BrainIcon,
    therapy_reminiscence: HistoryIcon,
    therapy_motor: DumbbellIcon,
    therapy_psychosocial: HeartHandshakeIcon,
    therapy_expressive: PaletteIcon,
    therapy_relaxation: WindIcon,
  };
  return map[imageKey] || BrainIcon;
}

function getColors(accent) {
  const map = {
    sky: { bg: "bg-sky-50", text: "text-sky-600" },
    blue: { bg: "bg-blue-50", text: "text-blue-600" },
    indigo: { bg: "bg-indigo-50", text: "text-indigo-600" },
    cyan: { bg: "bg-cyan-50", text: "text-cyan-600" },
    teal: { bg: "bg-teal-50", text: "text-teal-600" },
    emerald: { bg: "bg-emerald-50", text: "text-emerald-600" },
  };
  return map[accent] || map.sky;
}

export function Therapies({ modules = [], resolveImage }) {
  const { t } = useLandingLang();
  const safeModules = useMemo(
    () => (Array.isArray(modules) ? modules : []),
    [modules],
  );

  return (
    // CAMBIO AQUÍ: bg-slate-50 en lugar de bg-white
    <section
      id="terapias"
      className="py-24 px-6 text-center bg-slate-50 border-b border-slate-100"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 space-y-4">
          <span className="text-sky-500 !font-black tracking-widest uppercase text-xs">
            {t("therapiesTag")}
          </span>
          <h2 className="text-4xl !font-black tracking-tight text-slate-700">
            {t("therapiesTitle")}
          </h2>
          <p className="text-slate-500 max-w-2xl mx-auto font-medium">
            {t("therapiesDesc")}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {safeModules.map((m) => {
            const imgSrc =
              typeof resolveImage === "function"
                ? resolveImage(m.imageKey)
                : null;
            const { bg, text } = getColors(m.accent);
            const Icon = pickIcon(m.imageKey);

            return (
              <div
                key={m.titleKey}
                className="p-[1px] rounded-[2.5rem] bg-gradient-to-br from-sky-200/20 via-blue-200/25 to-indigo-300/20 shadow-sm hover:shadow-xl hover:shadow-sky-100/50 transition-all duration-500 group"
              >
                <div className="bg-white rounded-[calc(2.5rem-1px)] p-8 flex flex-col items-center h-full">
                  <div
                    className={`w-14 h-14 ${bg} ${text} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}
                  >
                    <Icon className="w-6 h-6" />
                  </div>
                  <div className="flex-1 flex flex-col items-center text-center">
                    <h3 className="text-lg !font-bold mb-3 uppercase tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-sky-500 to-blue-600">
                      {t(m.titleKey)}
                    </h3>
                    <p className="text-sm text-slate-500 leading-relaxed font-medium !mb-8">
                      {t(m.descKey)}
                    </p>
                  </div>
                  <div className="w-full aspect-video rounded-2xl bg-slate-50 border border-dashed border-slate-200 flex items-center justify-center overflow-hidden shrink-0 relative">
                    {imgSrc ? (
                      <img
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                        src={imgSrc}
                        alt={t(m.titleKey)}
                        loading="lazy"
                      />
                    ) : (
                      <ImageIcon className="w-8 h-8 text-slate-200" />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
